import React from "react";
import { Button, PageHeader, PageTitle } from "../index";
import { v4 as uuidv4 } from "uuid";

const LoopFieldsSet = ({
  title,
  titleConfig = {},
  data = [],
  onAdd,
  onRemove,
  renderFields,
  addButtonTitle = "Add more",
  minItems = 1,
  maxItems = 10,
  gridCols = "grid-cols-[repeat(6,1fr)_0.4fr]",
  className = "",
  showBuiltInRemoveButton = true,
  showBuiltInAddButton = true,
  addRemoveButtonsPosition = "header", // "header", "inline", "both"
  renderCustomButtons = null, // function to render custom buttons
}) => {
  const handleAdd = () => {
    if (onAdd && data.length < maxItems) {
      onAdd();
    }
  };

  const handleRemove = (id) => {
    if (onRemove && data.length > minItems) {
      onRemove(id);
    }
  };
  const defaultTitleConfig = {
    tag: "h4",
  };

  const mergedTitleConfig = {
    ...defaultTitleConfig,
    ...titleConfig,
  };

  return (
    <div className={className}>
      {title && (
        <div className="mt-6 mb-3">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={title} {...mergedTitleConfig} />
              </div>
            }
            RightSection={
              <div className="flex gap-2">
                {(addRemoveButtonsPosition === "header" ||
                  addRemoveButtonsPosition === "both") &&
                  showBuiltInAddButton && (
                    <Button
                      title={addButtonTitle}
                      size="sm"
                      icon={"add"}
                      variant="text"
                      color="info"
                      onClick={handleAdd}
                      disabled={data.length >= maxItems}
                    />
                  )}
                {renderCustomButtons && renderCustomButtons("header", null, -1)}
              </div>
            }
          />
        </div>
      )}
      <div>
        {data?.map((item, index) => (
          <div key={item.id || index} className="mb-7">
            <div className={`grid ${gridCols} gap-4`}>
              {renderFields(item, index)}

              {/* Inline buttons section */}
              <div className="flex gap-2 items-center pt-3">
                {(addRemoveButtonsPosition === "inline" ||
                  addRemoveButtonsPosition === "both") &&
                  showBuiltInAddButton && (
                    <Button
                      type="icon"
                      icon="add"
                      variant="text"
                      color="info"
                      size="sm"
                      onClick={handleAdd}
                      disabled={data.length >= maxItems}
                      title={addButtonTitle}
                    />
                  )}
                {data.length > minItems && showBuiltInRemoveButton && (
                  <Button
                    type="icon"
                    icon="delete"
                    variant="text"
                    color="error"
                    size="sm"
                    onClick={() => handleRemove(item.id)}
                  />
                )}
                {renderCustomButtons &&
                  renderCustomButtons("inline", item, index)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoopFieldsSet;
